import axios from "axios";
import React, { useEffect, useState } from "react";
import { showSuccess, showError } from "component/utils/SweetAlert";

const GroupAccountForm = ({ mode, user, closeModal, onSuccess }) => {
  const [formData, setFormData] = useState({
    group_account_table: "",
    group_account_div: "",
    div_code: "",
    group_account_dep: "",
    dep_code:"",
    group_account_code:"",
    int_code: "",
    group_account_desc: "",
    entry_by: user?.name,
    reg_desc: user?.company,
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });

    try {
      const response = await axios({
        method: mode === "add" ? "POST" : "PUT",
        url:
          mode === "add"
            ? `${process.env.REACT_APP_API}/insert-group-account`
            : '',
        data: formDataToSend,
        headers: {
          "Content-Type": "application/json",
        },
      });

      showSuccess(mode === "add" ? "Group Account berhasil ditambahkan" : "Group Account berhasil diperbarui");
      closeModal();
      if (onSuccess) onSuccess(user);

    } catch (error) {
      if (error.response) {
        if (error.response.status === 409) {
          showError(error.response.data.message || "Data sudah ada");
        } else {
          showError(error.response.data.message || "Terjadi kesalahan");
        }
      } else {
        showError("Terjadi kesalahan koneksi ke server.");
      }
    }
  };

  return (        
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{mode === "add" ? "Tambah Group Account" : "Edit Group Account"}</h5>
          <button type="button" className="btn-close" onClick={closeModal}></button>
        </div>
        <div className="modal-body">
          {/* <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="form-group mb-1">
              <label className="form-label">Group Account Table</label>
              <input
                type="text"
                name="group_account_table"
                className="form-control"
                placeholder="Isi Tabel Group"
                value={formData.group_account_table}
                onChange={handleChange}
              />
            </div>
            <div className="form-group mb-1">
              <label className="form-label">Group Account Div</label>
              <input
                type="text"
                name="group_account_div"
                className="form-control"
                placeholder="Isi Divisi Group"
                value={formData.group_account_div}
                onChange={handleChange}
              />
            </div>
            <div className="form-group mb-1">
              <label className="form-label">Div Code</label>
              <input
                type="text"
                name="div_code"
                className="form-control"
                placeholder="Isi Kode Divisi"
                value={formData.div_code}
                onChange={handleChange}
              />
            </div>
            <div className="form-group mb-1">
              <label className="form-label">Group Account Dep</label>
              <input
                type="text"
                name="group_account_dep"
                className="form-control"
                placeholder="Isi Departemen Group"
                value={formData.group_account_dep}
                onChange={handleChange}
              />
            </div>
            <div className="form-group mb-1">
              <label className="form-label">Dep Code</label>
              <input
                type="text"
                name="dep_code"
                className="form-control"
                placeholder="Isi Kode Departemen"
                value={formData.dep_code}
                onChange={handleChange}
              />
            </div>
            <div className="form-group mb-1">
              <label className="form-label">Group Account Desc</label>
              <input
                type="text"
                name="group_account_desc"
                className="form-control"
                placeholder="Isi Deskripsi"
                value={formData.group_account_desc}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group mb-1">
              <label className="form-label">Group Account Code</label>
              <input
                type="text"
                name="group_account_code"
                className="form-control"
                placeholder="Isi Group Account Code"
                value={formData.group_account_code}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group mb-1">
              <label className="form-label">INT Code</label>
              <input
                type="text"
                name="int_code"
                className="form-control"
                placeholder="Isi INT Code"
                value={formData.int_code}
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="btn btn-primary">
              {mode === "add" ? "Save" : "Update"}
            </button>
          </form> */}

          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Group Account Table</label>
              <div className="col-sm-8">
                <select
                  name="group_account_table"
                  className="form-control"
                  value={formData.group_account_table}
                  onChange={handleChange}
                >
                  <option value="" disabled>-- Pilih --</option>
                  <option value="NERACA">NERACA</option>
                  <option value="LABA RUGI">LABA RUGI</option>
                </select>
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Group Account Div</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="group_account_div"
                  className="form-control"
                  value={formData.group_account_div}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Div Code</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="div_code"
                  className="form-control"
                  value={formData.div_code}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Group Account Dep</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="group_account_dep"
                  className="form-control"
                  value={formData.group_account_dep}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Dep Code</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="dep_code"
                  className="form-control"
                  value={formData.dep_code}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Group Account Desc</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="group_account_desc"
                  className="form-control"
                  value={formData.group_account_desc}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">Group Account Code</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="group_account_code"
                  className="form-control"
                  value={formData.group_account_code}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <label className="col-sm-4 col-form-label">INT Code</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  name="int_code"
                  className="form-control"
                  value={formData.int_code}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="text-end">
              <button type="submit" className="btn btn-primary">
                {mode === "add" ? "Save" : "Update"}
              </button>
            </div>
          </form>

        </div>
      </div>
    </div>
  );
};

export default GroupAccountForm;
